<template>
  <footer :class="`theme-footer-seven ${dark_bg ? 'dark-bg' : ''}`">
    <div class="lg-container">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-2 mb-40" data-aos="fade-up" data-aos-duration="1200">
            <div class="logo"><router-link to="/">
              <img src="../../../assets/images/logo/logo-white.svg" alt=""></router-link>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 mb-40" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
            <h5 class="title">Links</h5>
            <ul class="footer-list">
              <li v-for="item in navLinks" :key="item._id">
                <a :href="item.linkType === 'email' ? `mailto:${item.href}` : item.href">
                  {{ item.linkText }}
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-4 mb-40" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="150">
            <h5 class="title">Legal</h5>
            <ul class="footer-list">
              <li v-for="item in legalLinks" :key="item._id">
                <a :href="item.linkType === 'email' ? `mailto:${item.email}?subject=Inquiry&body=---%0AContext: Footer -- link` : item.href">
                  {{ item.linkText }}
                </a>
              </li>
            </ul>
          </div>
          <div class="iso-certification-box col-xl-4 col-lg-5 mb-40 p-0" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
            <img src="../../../assets/images/iso-9001-certification.png" alt="ISO 9001 Certification" class="iso-certification" width="688" height="252">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="bottom-footer">
          <div class="row">
            <div class="col-md-6 order-lg-3 mb-20">
              <ul class="d-flex justify-content-center justify-content-lg-end social-icon">
                <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                <li><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
              </ul>
            </div>
            <div class="col-md-6 order-lg-2 mb-20">
              <p class="copyright justify-content-center justify-content-lg-start">Copyright ©{{ new Date().getFullYear() }} Marshall Print Ltd</p>
              <p><a class="siteby" href="https://23north.co.uk">Web Design | Bespoke Web Development | 23North - Sheffield</a></p>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- /.lg-container -->

  </footer>
</template>

<script>
import sanity from "../../../../sanity.js";
export default {
  name: 'FooterSeven',
  props:{
    dark_btn:Boolean,
    dark_bg:Boolean,
  },
  data() {
    return {
      loading: true,
      navLinks: [],
      legalLinks: [],
      error: null,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.error = this.home = null;
      this.loading = true;

      try {
        const footerNavQuery = `*[_type == "navigation" && title == "Header Navigation"]{navItems[]{_key, linkType, linkText, href, email}}`;
        const footerLegalsQuery = `*[_type == "navigation" && title == "Footer Legal Navigation"]{navItems[]{_key, linkType, linkText, href, email}}`;

        const [content, legalLinks] = await Promise.all([
          sanity.fetch(footerNavQuery),
          sanity.fetch(footerLegalsQuery)
        ]);

        this.navLinks = content[0].navItems;
        this.legalLinks = legalLinks[0].navItems;
        this.loading = false;

      } catch (error) {
        this.error = error;
        this.loading = false;
      }
    },
    onSubmit() {
      console.log('Submitted');
    }
  }
}
</script>

<style lang="scss" scoped>
.theme-footer-seven {
  padding: 3rem 0 1rem 0;
  .logo {
    img {
      height: 3rem;
      width: auto;
    }
  }
  .bottom-footer {
    margin: 0 auto;
    text-align: center;
    @media (min-width: 500px) {
      text-align: left;
    }
    p {
      text-align: center;
      @media (min-width: 500px) {
        text-align: left;
      }
    }
  }
  .iso-certification-box {
    display: flex;
    justify-content: flex-end;
    @media (max-width: 991px) {
      justify-content: flex-start;
    }
    .iso-certification {
      height: 8rem;
      width: 20rem;
    }
  }
  .siteby {
    font-size: 0.75rem;
  }
}
</style>
